/**
 * BuzzTalk copy. Carved out of en.ts so that file stays under the 500-line
 * ratchet while BuzzTalk keeps growing (archive confirm, tabs, empty states).
 */
export const enBuzzTalk = {
  'buzztalk.loadFailed': "Couldn't load your conversations. Retry to try again.",
  'buzztalk.retry': 'Retry',
  'buzztalk.loadingConversations': 'Loading conversations',
  'buzztalk.loadingMessages': 'Loading messages',
  'buzztalk.loadingTasks': 'Loading tasks',
  'buzztalk.loadingPages': 'Loading pages',
  'buzztalk.noGroups': 'No groups yet — create one to start chatting.',
  'buzztalk.selectGroup': 'Select a group from the list.',
  'buzztalk.newGroup': 'New group',
  'buzztalk.noMessages': 'No messages yet. Be the first to say hello.',
  'buzztalk.noSearchResults': 'No matches.',
  'buzztalk.emptyGroups': 'No groups yet.',
  'buzztalk.archivedSection': 'Archived',
  'buzztalk.archiveGroup': 'Archive group',
  'buzztalk.unarchiveGroup': 'Unarchive group',
  'buzztalk.archiveConfirmTitle': 'Archive Group',
  'buzztalk.archiveConfirmSubtitle': 'You can unarchive it later.',
  'buzztalk.archiveConfirmBody':
    'Are you sure you want to archive "{name}"? It will move to the Archived section and leave your active group list.',
  'buzztalk.archiveConfirmCancel': 'Cancel',
  'buzztalk.archiveConfirmYes': 'Archive Group',
  'buzztalk.archiveConfirmWorking': 'Archiving…',
  'buzztalk.createFirstGroup': 'Create your first group',
  'buzztalk.sendFailed': "Couldn't send your message. Try again.",
  'buzztalk.uploadFailed': "Couldn't upload that file. Try again.",
  'buzztalk.fileTooLarge': 'File is too large (max {max}MB).',
  'buzztalk.imageTypeUnsupported': 'Use JPEG, PNG, WebP, or GIF images.',
  'buzztalk.promoteFailed': "Couldn't promote that message to a task.",
  'buzztalk.promoteOk': 'Message promoted to a task.',
  'buzztalk.docsLoadFailed': "Couldn't load docs. Retry to try again.",
  'buzztalk.membersLoadFailed': "Couldn't load member lessons. Retry to try again.",
  'buzztalk.tabBuzzTalk': 'BuzzTalk',
  'buzztalk.tabDocs': 'Docs',
  'buzztalk.tabMembers': 'Members',
  'buzztalk.tabGetStarted': 'Get Started',
  'buzztalk.newCallLink': 'New call link',
  'buzztalk.newCallLinkShort': 'New',
} as const;
